import React from 'react';

function PrivacyPolicy({ onBack }) {
  return (
    <div style={{ padding: '40px 20px', maxWidth: '800px', margin: '0 auto' }}>
      <button
        onClick={onBack}
        style={{
          marginBottom: '20px',
          padding: '10px 20px',
          background: '#1890ff',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '1em',
        }}
      >
        ← 返回主页
      </button>

      <h1 style={{ fontSize: '2.5em', marginBottom: '30px', color: '#333' }}>隐私政策</h1>
      
      <div style={{ lineHeight: '1.8', fontSize: '1em', color: '#555' }}>
        <p style={{ marginBottom: '20px', color: '#999', fontSize: '0.95em' }}>
          最后更新日期：2025年1月
        </p>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '1.5em', color: '#1890ff', marginBottom: '15px' }}>1. 引言</h2>
          <p>
            欢迎使用削词侠（XIAOCIXIA）。我们非常重视您的隐私保护和个人信息安全。
            本隐私政策将向您说明我们如何收集、使用、存储和保护您的个人信息，
            以及您享有的相关权利。
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '1.5em', color: '#1890ff', marginBottom: '15px' }}>2. 我们收集的信息</h2>
          <p style={{ marginBottom: '10px' }}>我们可能收集以下类型的信息：</p>
          <ul style={{ paddingLeft: '20px' }}>
            <li style={{ marginBottom: '10px' }}>
              <strong>账户信息：</strong>电子邮箱地址、昵称、头像等注册信息
            </li>
            <li style={{ marginBottom: '10px' }}>
              <strong>学习数据：</strong>学习进度、已掌握词汇、学习时长等
            </li>
            <li style={{ marginBottom: '10px' }}>
              <strong>设备信息：</strong>设备型号、操作系统、浏览器类型等技术信息
            </li>
            <li style={{ marginBottom: '10px' }}>
              <strong>使用信息：</strong>功能使用情况、偏好设置等
            </li>
          </ul>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '1.5em', color: '#1890ff', marginBottom: '15px' }}>3. 信息的使用</h2>
          <p style={{ marginBottom: '10px' }}>我们使用收集的信息用于：</p>
          <ul style={{ paddingLeft: '20px' }}>
            <li style={{ marginBottom: '10px' }}>提供和改进我们的服务</li>
            <li style={{ marginBottom: '10px' }}>同步和保存您的学习进度</li>
            <li style={{ marginBottom: '10px' }}>个性化学习体验</li>
            <li style={{ marginBottom: '10px' }}>发送重要通知和更新</li>
            <li style={{ marginBottom: '10px' }}>分析和改进产品功能</li>
          </ul>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '1.5em', color: '#1890ff', marginBottom: '15px' }}>4. 信息的存储和保护</h2>
          <p>
            我们采用行业标准的安全措施来保护您的个人信息，包括但不限于：
          </p>
          <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
            <li style={{ marginBottom: '10px' }}>数据加密传输（HTTPS）</li>
            <li style={{ marginBottom: '10px' }}>Firebase安全规则保护</li>
            <li style={{ marginBottom: '10px' }}>定期安全审查和更新</li>
            <li style={{ marginBottom: '10px' }}>访问控制和权限管理</li>
          </ul>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '1.5em', color: '#1890ff', marginBottom: '15px' }}>5. 信息的共享</h2>
          <p>
            我们不会出售、出租或交易您的个人信息。我们仅在以下情况下可能共享您的信息：
          </p>
          <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
            <li style={{ marginBottom: '10px' }}>获得您的明确同意</li>
            <li style={{ marginBottom: '10px' }}>法律法规要求</li>
            <li style={{ marginBottom: '10px' }}>为保护用户、公众或削词侠的权利、财产或安全</li>
          </ul>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '1.5em', color: '#1890ff', marginBottom: '15px' }}>6. 您的权利</h2>
          <p style={{ marginBottom: '10px' }}>您对自己的个人信息享有以下权利：</p>
          <ul style={{ paddingLeft: '20px' }}>
            <li style={{ marginBottom: '10px' }}>访问和获取您的个人信息副本</li>
            <li style={{ marginBottom: '10px' }}>更正不准确或不完整的信息</li>
            <li style={{ marginBottom: '10px' }}>删除您的账户和个人信息</li>
            <li style={{ marginBottom: '10px' }}>撤回同意或拒绝某些信息处理</li>
          </ul>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '1.5em', color: '#1890ff', marginBottom: '15px' }}>7. Cookie和类似技术</h2>
          <p>
            我们使用Cookie和类似技术来改善用户体验、记住您的偏好设置。
            您可以通过浏览器设置管理Cookie偏好。
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '1.5em', color: '#1890ff', marginBottom: '15px' }}>7.1 Google AdSense和广告Cookie</h2>
          <p>
            本网站使用Google AdSense展示广告。Google及第三方供应商使用Cookie根据用户之前访问本网站或其他网站的情况投放广告。
          </p>
          <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
            <li style={{ marginBottom: '10px' }}>
              Google使用广告Cookie使其能够根据用户对本网站和网络上其他网站的访问情况向用户展示广告
            </li>
            <li style={{ marginBottom: '10px' }}>
              用户可以通过访问
              <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer" style={{ color: '#1890ff', marginLeft: '5px' }}>
                广告设置
              </a>
              选择停用Google的个性化广告
            </li>
            <li style={{ marginBottom: '10px' }}>
              用户也可以通过访问
              <a href="http://www.aboutads.info" target="_blank" rel="noopener noreferrer" style={{ color: '#1890ff', marginLeft: '5px' }}>
                aboutads.info
              </a>
              选择停用第三方供应商对Cookie的使用
            </li>
          </ul>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '1.5em', color: '#1890ff', marginBottom: '15px' }}>8. 儿童隐私</h2>
          <p>
            我们的服务适用于所有年龄段的学习者。对于18岁以下的用户，
            我们建议在家长或监护人的指导下使用本服务。
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '1.5em', color: '#1890ff', marginBottom: '15px' }}>9. 政策更新</h2>
          <p>
            我们可能会不时更新本隐私政策。重大变更时，我们会通过适当方式通知您。
            建议您定期查看本政策以了解最新信息。
          </p>
        </section>

        <section>
          <h2 style={{ fontSize: '1.5em', color: '#1890ff', marginBottom: '15px' }}>10. 联系我们</h2>
          <p>
            如果您对本隐私政策有任何疑问或建议，请通过以下方式联系我们：
          </p>
          <p style={{ marginTop: '10px' }}>
            电子邮箱：
            <a href="mailto:vincentyipcom@gmail.com" style={{ color: '#1890ff', textDecoration: 'none', marginLeft: '5px' }}>
              vincentyipcom@gmail.com
            </a>
          </p>
        </section>
      </div>
    </div>
  );
}

export default PrivacyPolicy;